import { CheckIcon } from '@cian/ui-kit/prev';
import { CheckboxView } from '@cian/ui-kit/prev/checkbox/view';
import * as React from 'react';
import classNames from 'classnames';

import { ISelectOption } from '../../types';

import * as styles from './selectPopupOption.css';

interface ISelectPopupOptionProps {
  option: ISelectOption;
  index: number;
  multiple?: boolean;
  focused: boolean;
  selected: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick(e: React.MouseEvent<HTMLDivElement>, index: number): any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMouseMove(e: React.MouseEvent<HTMLDivElement>, index: number): any;
  forwardedRef?: React.RefObject<HTMLDivElement>;
}

export class SelectPopupOption extends React.Component<ISelectPopupOptionProps> {
  public render() {
    return (
      <div
        ref={this.props.forwardedRef}
        className={classNames(
          styles['option'],
          this.props.focused && styles['focused'],
          this.props.multiple && styles['multiple'],
        )}
        onClick={this.handleClick}
        onMouseMove={this.handleMouseMove}
      >
        {this.renderIcon()}

        {this.props.option.label}
      </div>
    );
  }

  private renderIcon() {
    if (this.props.multiple) {
      return <CheckboxView checked={!!this.props.selected} className={styles['checkbox']} />;
    }

    return (
      this.props.selected && (
        <CheckIcon
          __classNames={styles['icon']}
          custom={{
            size: '12',
          }}
          styles={{
            color: '2B87DB',
          }}
        />
      )
    );
  }

  private handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.props.onClick(e, this.props.index);
  };

  private handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    this.props.onMouseMove(e, this.props.index);
  };
}
